import { render, staticRenderFns } from "./TokenUseGuideline.vue?vue&type=template&id=569c362c&scoped=true&"
import script from "./TokenUseGuideline.vue?vue&type=script&lang=js&"
export * from "./TokenUseGuideline.vue?vue&type=script&lang=js&"
import style0 from "./TokenUseGuideline.vue?vue&type=style&index=0&id=569c362c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569c362c",
  null
  
)

export default component.exports